export const PopupLayout = {
  horizontalPaddings: '--popup-layout-horizontal-paddings',
  headerBottomPadding: '--popup-layout-header-bottom-paddings',
  motnHorizontalPaddings: '--popup-layout-motn-horizontal-paddings',
  motnHeaderBottomPadding: '--popup-layout-motn-header-bottom-paddings',
} as const
export type PopupLayout = (typeof PopupLayout)[keyof typeof PopupLayout]
